import { lazy, Suspense } from 'react'
import Loading from '../Loading'
import SoldsDataTable from './ADMIN/components/SoldsDataTable'
import TrafficStatsTable from './TrafficStatsTable'

const LastsSubject = lazy(() => import('../loops/LastsSubject'))

export default function AdminDashboard() {
  return (
    <>
      <div className="is_content">
        <div className="contentHolder">
          <div className="row">
            <div className="col-12">
              <Suspense fallback={<Loading styles="mini" />}>
                <LastsSubject page={1} pageSize={8} />
              </Suspense>
            </div>
          </div>

          <Suspense fallback={<Loading styles="mini" />}>
            <SoldsDataTable />
          </Suspense>

          <div className="row">
            <div className="col-md-12">
              <TrafficStatsTable
                title="ترافیک کاربران"
                source="admin"
                priceField="publisherPrice"
                bordered
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
